import { splitIntoSegments } from "./utils/markdownParser";
import { CardBlock } from "./components/CardBlock";
import { TimelineBlock } from "./components/TimelineBlock";
import { TextBlock } from "./components/TextBlock";


type MarkdownProps = {
  children: string;
  typingEffect?: boolean;
};


const Markdown = ({ children, typingEffect = true }: MarkdownProps) => {
  const segments = splitIntoSegments(children);
  return (
    <div>
        {segments.map((seg, idx) => {
            if (seg.type === "text") return <TextBlock key={idx} content={seg.content} typingEffect={typingEffect} />; 
            if (seg.type === "card") return <CardBlock key={idx} content={seg.content} />;
            if (seg.type === "timeline") return <TimelineBlock key={idx} items={seg.items} />;
            return "";
          })}

    </div>
  );
};

export default Markdown;
 

 